import type { DocumentationFileCategory } from './applicationDocumentation.types';

export const DOCUMENTATION_MENU_ITEM_VALUE = {
  addFiles: 'add-files',
  addLinks: 'add-links',
} as const;

export type ApplicationDocumentationInitialAction =
  (typeof DOCUMENTATION_MENU_ITEM_VALUE)[keyof typeof DOCUMENTATION_MENU_ITEM_VALUE];

export const MAX_APPLICATION_DOCS_FILES = 10;

export const MAX_APPLICATION_DOCS_FILE_SIZE_BYTES = 50 * 1024 * 1024;

export const ACCEPT_APPLICATION_DOCS = '.pdf,.doc,.docx,.md,.txt';

export const ACCEPT_API_DOCS = '.json,.yaml,.yml,.swagger';

export const ACCEPT_TESTING_REPORTS = '.pdf,.doc,.docx,.html,.json,.xml';

export const DOCUMENTATION_FILE_ACCEPT: Record<
  DocumentationFileCategory,
  string
> = {
  application: ACCEPT_APPLICATION_DOCS,
  api: ACCEPT_API_DOCS,
  'testing-reports': ACCEPT_TESTING_REPORTS,
};

export const EMPTY_STAGED_DOCUMENTATION_FILES: Record<
  DocumentationFileCategory,
  File[]
> = {
  application: [],
  api: [],
  'testing-reports': [],
};
